import { ReactComponent as ApiKeySvg } from 'common/assets/images/api_key.svg';

/** API key glyph for the mobile header entry point. */
export function ApiKeyIcon({
  className,
  width = 24,
  height = 24,
}: {
  className?: string;
  width?: number;
  height?: number;
}): JSX.Element {
  return (
    <ApiKeySvg
      className={className}
      width={width}
      height={height}
      aria-hidden
    />
  );
}
